export enum GalleryViewMode {
  List,
  Cards
}
